<div class="pickup-page">
  <div class="pickup-content">
    <div class="pickup-header">
      <button type="button" class="back-button" (click)="this.back()" aria-label="Назад">
        <img src="/assets/images/shared/back.svg" alt="">
      </button>
      <h2>Избери офис</h2>
    </div>

    <form [formGroup]="this.pickupInfo" class="pickup-form">
      <div class="section-title">Данни за получателя</div>

      <input type="text" class="form-control" formControlName="first_name" placeholder="Име*">
      <input type="text" class="form-control" formControlName="last_name" placeholder="Фамилия*">
      <input type="text" class="form-control" formControlName="phone" placeholder="Телефонен номер*">

      <div class="section-title office-section-title">Населено място</div>
      <div class="search-field">
        <i class="bi bi-geo-alt"></i>
        <input
          type="text"
          autocomplete="off"
          [value]="this.city"
          (input)="this.onCityInput($event)"
          placeholder="Избери населено място">
        <i class="bi bi-chevron-down field-action"></i>
      </div>

      <div class="suggestions" *ngIf="this.showCityResults">
        <div class="loading-row" *ngIf="this.cityLoading">Търсене...</div>
        <button
          type="button"
          class="suggestion-item"
          *ngFor="let cityItem of this.cities.data.results"
          (click)="this.selectCity(cityItem)">
          <i class="bi bi-geo-alt"></i>
          <span>{{ cityItem.value }}</span>
        </button>
        <div class="empty-row" *ngIf="!this.cityLoading && !this.cities.data.results.length">
          Няма намерени населени места
        </div>
      </div>

      <div class="section-title office-section-title">Избери офис на Спиди</div>
      <div class="search-field" [class.disabled]="!this.hasSelectedCity">
        <i class="bi bi-search"></i>
        <input
          type="text"
          [disabled]="!this.hasSelectedCity"
          [value]="this.officeSearch"
          (input)="this.onOfficeSearch($event)"
          placeholder="Търси офис, квартал или улица">
      </div>

      <div class="office-hint" *ngIf="!this.hasSelectedCity">
        Избери населено място, за да видиш офисите на Speedy.
      </div>

      <div class="loading-row office-loading" *ngIf="this.hasSelectedCity && this.officesLoading">
        Зареждане на офисите...
      </div>

      <div class="office-list" *ngIf="this.hasSelectedCity && !this.officesLoading">
        <button
          type="button"
          class="office-card"
          [class.selected]="this.selectedOfficeId === office.id"
          *ngFor="let office of this.offices.data.results; trackBy: this.trackOfficeById"
          (click)="this.selectOffice(office)">
          <div class="office-pin">
            <i class="bi bi-geo-alt-fill"></i>
          </div>
          <div class="office-details">
            <strong>{{ office.name }}</strong>
            <span>{{ office.address.fullAddressString }}</span>
            <small *ngIf="office.workingTimeFrom && office.workingTimeTo">
              <i class="bi bi-clock"></i>
              Пн-Пт: {{ office.workingTimeFrom }} - {{ office.workingTimeTo }}
            </small>
          </div>
          <div class="office-select-indicator">
            <i class="bi" [ngClass]="this.selectedOfficeId === office.id ? 'bi-check-circle-fill' : 'bi-circle'"></i>
          </div>
        </button>

        <div class="empty-row" *ngIf="!this.offices.data.results.length">
          Няма намерени офиси за зададеното търсене.
        </div>
      </div>
    </form>
  </div>

  <div class="pickup-footer">
    <div class="office-info-box" role="note">
      <i class="bi bi-info-circle-fill" aria-hidden="true"></i>
      <div class="office-info-content">
        <strong>Ще получите SMS/Viber, когато пратката е в офиса.</strong>
      </div>
    </div>

    <button
      type="button"
      [disabled]="!this.pickupInfo.valid"
      class="btn btn-primary save-button"
      (click)="this.choosePickup()">
      Запази
    </button>
  </div>
</div>
